<template>
  <div class="appDownload">
    <el-dialog v-dialogDrag :visible.sync="downloadDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      title="插件下载" width="500px">
      <div class="downunit">
        <img :src="$showLogo||$appLogo" :alt="$appTitle" class="downunit-bottom" :onerror="`this.src='${$defaultLogo}'`" />
        <span class="downunit-bottom downunit-font">{{ $appTitle }}</span>
        <div class="downSilder">
          <div>
            <el-button type="primary" size="small" class="downunit-bottom" @click="downPlugBtn">REVIT插件下载</el-button>
            <span class="downunit-bottom">更新时间：{{ plugForm.createTime }}</span>
          </div>
          <div v-if="appForm.createTime">
            <el-button type="primary" size="small" class="downunit-bottom" @click="downAppBtn">APP下载</el-button>
            <span class="downunit-bottom">更新时间：{{ appForm.createTime }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import enterpriseService from "@/CommonDP/service/enterprise-service";
import { downloadFile } from "@/CommonDP/utils";
export default {
  props: {
    plugForm: {
      type: Object,
      default: () => {}
    },
    appForm: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      downloadDialog: true
    };
  },
  methods: {
    downPlugBtn() {
      if (this.plugForm.filePath) {
        const fileUrl = enterpriseService.downloadUrlone(this.plugForm.filePath);
        downloadFile(fileUrl);
      } else {
        this.$message.warning("暂无文件");
      }
    },
    // app下载
    downAppBtn() {
      if (this.appForm.filePath) {
        const fileUrl = enterpriseService.downloadUrlone(this.appForm.filePath);
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.style.height = 0;
        iframe.src = fileUrl;
        document.body.appendChild(iframe);
        setTimeout(() => {
          iframe.remove();
        }, 5 * 60 * 1000);
      } else {
        this.$message.warning("暂无文件");
      }
    },
    showDialog() {
      this.downloadDialog = true;
    }
  }
};
</script>

<style scoped lang="scss">
.appDownload {
  width: 100%;
  height: 70px;
  .downunit {
    display: flex;
    flex-direction: column;
    align-items: center;
    .downunit-bottom {
      margin-bottom: 10px;
      img {
        height: 50px;
        width: 50px;
      }
    }
    .downunit-font {
      font-weight: 600;
      font-size: 20px;
      letter-spacing: 2px;
    }
    .downSilder {
      width: 100%;
      margin-top: 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      div {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
}
</style>
